import { useMemo } from 'react';
import { categories } from '../util/categoryDefinitions';

export default (categoryIds: any) => {
  return useMemo(() => {
    return categories
      .filter((category: any) => categoryIds.includes(category.id))
      .sort((a: any, b: any) => categoryIds.indexOf(a.id) - categoryIds.indexOf(b.id));
  }, [categoryIds]);
};
